import './sentryConfig';
import './main.scss';
import './websked-core/core';
import './settings/settings';
import './search/search';
import './stories/stories';
import './homepage/homepage';
import './plans/plans';
import './tasks/tasks';
import pubsRoutes from './publications/pubsRoutes';
import statsRoutes from './stats/statsRoutes';

const routesToBootstrap = [
  pubsRoutes,
  statsRoutes
];

const websked = angular.module('websked', [
  'websked.core',
  'websked.settings',
  'websked.search',
  'websked.stories',
  'websked.homepage',
  'websked.plans',
  'websked.tasks'
]);

function mainRoutes($locationProvider, $stateProvider, $urlRouterProvider) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('sentry', {
      url: '/sentry-debugging',
      controller: [
        '$timeout',
        function DebugCtrl($timeout) {
          $timeout(() => {
            throw new Error('Testing Sentry and error reporting');
          }, 2000);
        }
      ],
      template: `<h3 class="p1">
                  Page Not Found
                </h3>`,
      data: {
        pageTitle: {
          de: '404',
          en: '404',
          es: '404',
          fr: '404'
        }
      }
    });
}

websked.config([
  '$locationProvider',
  '$stateProvider',
  '$urlRouterProvider',
  mainRoutes
]);

routesToBootstrap.forEach((route) => {
  route(websked);
});
